export default __webpack_public_path__ + "static/favicon-934e16d3d186cfd8844f55415badcac0.ico";